var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var Map = getNative(global, 'Map');

module.exports = Map;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_Map.js
 ** module id = 203
 ** module chunks = 0
 **/